import { useState } from 'react';
import './WelcomeModal.css';

export default function WelcomeModal({ onStart, onSkip }) {
  const [isClosing, setIsClosing] = useState(false);

  const handleStart = () => {
    setIsClosing(true);
    setTimeout(() => onStart(), 300);
  };

  const handleSkip = () => {
    setIsClosing(true);
    setTimeout(() => onSkip(), 300);
  };

  return (
    <div className={`welcome-modal-overlay ${isClosing ? 'closing' : ''}`}>
      <div className={`welcome-modal-content ${isClosing ? 'closing' : ''}`}>
        {/* Welcome Icon */}
        <div className="welcome-icon">
          🎉
        </div>

        {/* Heading */}
        <h2 className="welcome-heading">
          Welcome to Krinos AI!
        </h2>

        {/* Subheading */}
        <p className="welcome-subheading">
          Your Professional HVAC Assessment Platform
        </p>

        {/* Description */}
        <div className="welcome-description">
          <p>We're excited to have you on board! Let's get you set up so you can start creating professional HVAC assessments for your customers.</p>

          <p>Our quick setup wizard will help you configure:</p>

          <ul className="welcome-checklist">
            <li>
              <span className="check-icon">✓</span>
              <span>Company information and branding</span>
            </li>
            <li>
              <span className="check-icon">✓</span>
              <span>Geographic service areas</span>
            </li>
            <li>
              <span className="check-icon">✓</span>
              <span>Climate zone settings</span>
            </li>
            <li>
              <span className="check-icon">✓</span>
              <span>Local utility providers and rebates</span>
            </li>
          </ul>

          <p className="welcome-note">
            <strong>Note:</strong> You can skip this setup and complete it later, but you'll need to finish it before creating your first assessment.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="welcome-actions">
          <button
            onClick={handleStart}
            className="btn-welcome-start"
          >
            Let's Get Started! →
          </button>
          <button
            onClick={handleSkip}
            className="btn-welcome-skip"
          >
            Skip for Now
          </button>
        </div>

        {/* Footer */}
        <div className="welcome-footer">
          Need help? Check out our <a href="#" onClick={(e) => e.preventDefault()}>Quick Start Guide</a>
        </div>
      </div>
    </div>
  );
}
